import { gql } from "@apollo/client";

export const GET_CLIP_REWARDS = gql`
  query GetClipRewards {
    me {
      id
      clipQuotaNew {
        eligible
        tier
        limit
        baseLimit
        used
        resetsAt
        referralCredits
        freeDays
        freeDayLimit
        streakDays
        canClaimToday
        boosts {
          type
          clips
          completed
          steps {
            step
            completed
          }
        }
      }
    }
  }
`;

// ALL-2072: the claim is what grants the clip, so the reply carries the new
// quota and callers do not need to refetch.
export const CLAIM_DAILY_CLIP = gql`
  mutation DailyClipClaim {
    dailyClipClaim {
      eligible
      limit
      used
      freeDays
      freeDayLimit
      streakDays
      canClaimToday
    }
  }
`;
